module.exports = __webpack_public_path__ + "static/media/Panorama-Alicante-mountains.f0b2ea21.jpg";